import React from "react";
import { View, StyleSheet } from "react-native";
import NtMarketingSectionContainer from "../general/NtMarketingSectionContainer";
import tos from "./data/tos.html";
import css from "./data/css.html";

function NtExtrasTosInfoSection(props) {
  return (
    <NtMarketingSectionContainer style={styles.container}>
      <View style={{}}>
        <main>
          <div dangerouslySetInnerHTML={{ __html: tos }} />
          <div dangerouslySetInnerHTML={{ __html: css }} />
        </main>
      </View>
    </NtMarketingSectionContainer>
  );
}

const styles = StyleSheet.create({
  container: {
    paddingTop: 60,
    paddingBottom: 60,
  },
});

export default NtExtrasTosInfoSection;
